<div class="day-wrapper">
  <h4 class="day-name">{{ name }}</h4>
  <h4 class="day">{{ day }}</h4>
</div>

<div class="day-column-wrapper">
  <div class="encouragements-wrapper" *ngIf="encouragements && encouragements.length > 0">
    <msd-encouragement-card *ngFor="let encouragement of encouragements"
                            [initials]="dietitian?.initials"
                            [message]="encouragement.message"
                            [pictureUrl]="dietitian?.picture?.url"
                            [reaction]="encouragement.reaction">
    </msd-encouragement-card>
    <hr />
  </div>
  <div class="notebooks-wrapper" *ngIf="entries && entries.length > 0; else empty">
    <msd-diary-card (onCommentEdit)="commentEdit(diary, $event)"
                    *ngFor="let diary of entries"
                    [comment]="diary.comment"
                    [isCommentLoading]="diary?.diaryId?.id?.toString() === diaryCommentLoadingId"
                    [name]="diary.name"
                    [pictures]="getPicturesUrls(diary.pictures)"
                    [timestamp]="diary.createdAt"
                    [trackers]="diary.givenTrackers"
                    [type]="diary.type"
                    [diaryType]="diary.diaryType"></msd-diary-card>
  </div>
<!--  <div *ngIf="entries.length > 0" class="msd-ai-wrapper">-->
<!--    <button class="btn btn-primary btn-gradient" (click)="testAi()">Test</button>-->
<!--  </div>-->
  <ng-template #empty>
    <h3 class="empty-data-text">Aucune activité</h3>
  </ng-template>
</div>
